module.exports = __webpack_public_path__ + "static/media/pic5.8cb41e52.jpg";